module.exports = __webpack_public_path__ + "img/jlg_header.ca174594.png";